import { callAPI } from "../../_common/Api";

const setField = (
  id,
  isActive,
  isMandatory,
  label,
  value,
  customFieldType = "",
  customFieldName = ""
) => ({
  id,
  isActive: isActive === "t" ? true : false,
  isMandatory: isMandatory === "t" ? true : false,
  label,
  value,
  type: customFieldType,
  name: customFieldName,
});

const getCustomFieldValue = (id, api950Data) => {
  if (api950Data.customFields && api950Data.customFields.length > 0) {
    for (let i = 0; i < api950Data.customFields.length; i++) {
      const field = api950Data.customFields[i];
      if (field[0] === id) {
        return field[1];
      }
    }
  } else {
    return "";
  }
};

export const getAPIRegistrationFields = async (skin, api950Data, language) => {
  const api1024Data = await callAPI(skin, "dc_1024", {
    params: [language, "1024", "mqid", "mqpass", "customer"],
    id: "1024",
  });

  if (api1024Data.result.I0) {
    const apiFields = api1024Data.result.I2;
    const customFields = api1024Data.result.I3;
    const newAccountInfo = {
      login: setField(
        "login",
        "t",
        "t",
        "Login",
        api950Data.login ? api950Data.login : api950Data.email
      ),
      password: setField("password", "t", "t", "Password", ""),
      title: setField("title", apiFields[1][2], apiFields[1][3], apiFields[1][1], api950Data.title),
      firstName: setField(
        "first-name",
        apiFields[2][2],
        apiFields[2][3],
        apiFields[2][1],
        api950Data.firstName
      ),
      middleName: setField(
        "middle-name",
        apiFields[3][2],
        apiFields[3][3],
        apiFields[3][1],
        api950Data.middleName
      ),
      lastName: setField(
        "last-name",
        apiFields[4][2],
        apiFields[4][3],
        apiFields[4][1],
        api950Data.lastName
      ),
      gender: setField(
        "gender",
        apiFields[5][2],
        apiFields[5][3],
        apiFields[5][1],
        api950Data.gender
      ),
      birthdate: setField(
        "birth-date",
        apiFields[6][2],
        apiFields[6][3],
        apiFields[6][1],
        api950Data.birthday
      ),
      address: setField(
        "address",
        apiFields[7][2],
        apiFields[7][3],
        apiFields[7][1],
        api950Data.address
      ),
      address2: setField("address2", apiFields[8][2], apiFields[8][3], apiFields[8][1], null),
      city: setField("city", apiFields[9][2], apiFields[9][3], apiFields[9][1], api950Data.city),
      province: setField(
        "province",
        apiFields[10][2],
        apiFields[10][3],
        apiFields[10][1],
        api950Data.province
      ),
      county: setField(
        "county",
        apiFields[11][2],
        apiFields[11][3],
        apiFields[11][1],
        api950Data.county
      ),
      country: setField(
        "country",
        apiFields[12][2],
        apiFields[12][3],
        apiFields[12][1],
        api950Data.country
      ),
      postal: setField(
        "postal",
        apiFields[13][2],
        apiFields[13][3],
        apiFields[13][1],
        api950Data.postal
      ),
      phone: setField(
        "phone",
        apiFields[14][2],
        apiFields[14][3],
        apiFields[14][1],
        api950Data.phone
      ),
      promoOptInEmail: setField(
        "promo-opt-in-email",
        apiFields[16][2],
        apiFields[16][3],
        apiFields[16][1],
        api950Data.optInEmail
      ),
      mobile: setField(
        "cell-number",
        apiFields[19][2],
        apiFields[19][3],
        apiFields[19][1],
        api950Data.mobile
      ),
      promoOptInMail: setField(
        "promo-opt-in-mail",
        apiFields[21][2],
        apiFields[21][3],
        apiFields[21][1],
        api950Data.promotionOptInMail
      ),
      memberType: setField(
        "member-type",
        apiFields[22][2],
        apiFields[22][3],
        apiFields[22][1],
        api950Data.memberType
      ),
      CPFNumber: setField(
        "cpf-number",
        apiFields[26][2],
        apiFields[26][3],
        apiFields[26][1],
        api950Data.cpfNumber
      ),
    };

    if (customFields && customFields.length > 0) {
      newAccountInfo.customFields = [];
      customFields.forEach((field, index) => {
        newAccountInfo.customFields.push(
          setField(
            field[4],
            "t",
            field[2],
            field[1],
            getCustomFieldValue(field[4], api950Data),
            field[3],
            field[0]
          )
        );
      });
    }
    return newAccountInfo;
  }
};
